

export default class SimilarityGoods{
    constructor(){
        this._similaritygoods = [];
        this._selected = [];
        this._parent = null;
    }

    setParent(parent){
        this._parent = parent;
    }
    
    init(data){        
        if(data.goodsDetails ){   
            let res = [];
            let _goodsDetails = data.goodsDetails;
            let _position = data.recommedResult && data.recommedResult.position;
            for(let p in _position){
                for(let i in _goodsDetails){
                    if(_position[p].codes == i){
                        let _goods = _goodsDetails[i].detail;                        
                        _goods.goodsCode = i;                        
                        _goods.position = p;
                        _goods.strategy = _position[p].flag;
                        _goods.price = _goodsDetails[i].price;
                        res.push(_goods);
                    }                    
                }
            }
            this._similaritygoods = res;
        }        
    }    
}